import ScrollReveal from '@/components/base/ScrollReveal';
import { Link } from 'react-router-dom';
import { articles } from '@/mocks/dramas';

export default function ArticlePreview() {
  const previewArticles = articles.slice(0, 4);

  return (
    <ScrollReveal>
    <section className="max-w-[1400px] mx-auto px-4 md:px-6 py-12 md:py-16">
      <div className="flex items-center justify-between mb-8">
        <div>
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-100">
            <i className="ri-article-line text-secondary-500 mr-2"></i>
            追剧指南
          </h2>
          <p className="text-sm text-foreground-500 mt-1">精选剧评与推荐，帮你发现好剧</p>
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {previewArticles.map((article) => (
          <Link
            key={article.id}
            to={`/article/${article.id}`}
            className="group bg-background-50 rounded-xl p-5 border border-background-300/60 hover:border-secondary-500/30 hover:-translate-y-1 transition-all duration-300 cursor-pointer"
          >
            <div className="flex items-center gap-2 mb-3">
              <span className="text-xs bg-secondary-100 text-secondary-700 px-2 py-0.5 rounded-full">
                {article.category}
              </span>
              <span className="text-xs text-foreground-500">{article.date}</span>
            </div>
            <h3 className="text-sm font-medium text-foreground-200 group-hover:text-primary-500 transition-colors duration-200 mb-2 line-clamp-2 leading-relaxed">
              {article.title}
            </h3>
            <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2 mb-3">
              {article.excerpt}
            </p>
            <div className="flex items-center justify-between">
              <span className="text-xs text-foreground-600">{article.author}</span>
              <span className="text-xs text-foreground-600">
                <i className="ri-eye-line mr-1"></i>{article.views.toLocaleString()}
              </span>
            </div>
          </Link>
        ))}
      </div>
    </section>
    </ScrollReveal>
  );
}